module.exports = __webpack_public_path__ + "static/plain-medium-8aaa5333cd5fd4e05369a770689d92d5.woff";